import React, { useState, useEffect, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const ChatWidget = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState([
    { role: 'assistant', text: 'Initialize sequence complete. I am MidnightNeuron\'s neural proxy. How can I assist your build today?' }
  ]);
  const [input, setInput] = useState('');
  const [isTyping, setIsTyping] = useState(false);
  const scrollRef = useRef(null);

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  }, [messages, isTyping]);

  const handleSend = async (e) => {
    e.preventDefault();
    if (!input.trim()) return;

    const userMessage = input.trim();
    setMessages(prev => [...prev, { role: 'user', text: userMessage }]);
    setInput('');
    setIsTyping(true);

    setTimeout(() => {
      let response = "Analyzing request... Suggest contacting MidnightNeuron directly for complex queries.";
      if (userMessage.toLowerCase().includes('hello')) response = "Greetings. Connection established.";
      setMessages(prev => [...prev, { role: 'assistant', text: response }]);
      setIsTyping(false);
    }, 1500);
  };

  return (
    <div className="fixed bottom-6 right-6 z-[200] flex flex-col items-end">
      <AnimatePresence>
        {isOpen && (
          <motion.div 
            initial={{ opacity: 0, scale: 0.9, y: 20 }} 
            animate={{ opacity: 1, scale: 1, y: 0 }} 
            exit={{ opacity: 0, scale: 0.9, y: 20 }} 
            className="mb-4 w-[320px] sm:w-[380px] bg-obsidian border border-neon-cyan/30 shadow-2xl overflow-hidden flex flex-col h-[500px]"
          >
            <div className="h-40 relative bg-charcoal border-b border-white/10 overflow-hidden">
              <iframe src='https://my.spline.design/genkubgreetingrobot-uBYybPMh7H3SAK9Nks3sDCpH/' frameBorder='0' width='100%' height='100%' className="scale-150 mt-4" ></iframe>
            </div>
            <div ref={scrollRef} className="flex-grow overflow-y-auto p-4 space-y-4 bg-grid-pattern bg-[size:20px_20px]">
              {messages.map((msg, idx) => (
                <div key={idx} className={`flex ${msg.role === 'user' ? 'justify-end' : 'justify-start'}`}>
                  <div className={`max-w-[85%] p-3 text-xs font-mono leading-relaxed ${msg.role === 'user' ? 'bg-neon-cyan/10 border border-neon-cyan/30 text-white rounded-l-lg' : 'bg-steel/50 border border-white/10 text-gray-300 rounded-r-lg'}`}>
                    {msg.text}
                  </div>
                </div>
              ))}
            </div>
            <form onSubmit={handleSend} className="p-4 bg-charcoal border-t border-white/10 flex gap-2">
              <input type="text" value={input} onChange={(e) => setInput(e.target.value)} placeholder="Enter command..." className="flex-grow bg-obsidian border border-white/10 p-2 text-xs text-white focus:border-neon-cyan focus:outline-none font-mono" />
              <button type="submit" className="bg-neon-cyan/10 border border-neon-cyan p-2 text-neon-cyan hover:bg-neon-cyan hover:text-black transition-colors">
                <SafeIcon icon={FiIcons.FiSend} />
              </button>
            </form>
          </motion.div>
        )}
      </AnimatePresence>
      <button onClick={() => setIsOpen(!isOpen)} className={`w-14 h-14 rounded-full flex items-center justify-center transition-all duration-300 shadow-lg ${isOpen ? 'bg-red-500/10 border border-red-500 text-red-500' : 'bg-neon-cyan/10 border border-neon-cyan text-neon-cyan shadow-[0_0_15px_rgba(0,240,255,0.3)]'}`}>
        <SafeIcon icon={isOpen ? FiIcons.FiX : FiIcons.FiMessageSquare} className="text-2xl" />
      </button>
    </div>
  );
};

export default ChatWidget;